// 后端错误码 -> 中文消息映射
export const ERROR_MESSAGES: Record<number, string> = {
  // 认证/参数
  1000: '参数错误',
  1001: '用户名或密码错误',
  1002: '用户不存在',
  1003: '用户已存在',
  1004: '登录失败次数过多，账户已锁定',
  1005: '账户审核中，请等待管理员审核',
  1007: '密码强度不足',
  1008: '用户名格式不合法',
  1009: '账号已被禁用',

  // 卡密
  2001: '卡密不存在',
  2002: '卡密已使用',
  2003: '卡密已过期',
  2004: '卡密验证失败',
  2005: '您已使用过此卡密',
  2006: '卡密使用次数已达上限',
  2007: '卡密已禁用',
  2008: '卡密正在使用中，请稍后重试',
  2009: '卡密生成失败',
  2010: '生成数量无效',
  2011: '有效期天数无效',

  // 应用/代理商/实体
  3001: '应用不存在',
  3002: '应用已禁用',
  3003: '代理商不存在',
  3004: '代理关系已存在',
  3005: '代理关系不存在或未审核通过',
  3006: '无权为该应用生成卡密',
  3007: '代理商已被禁用',
  3008: '销售价格无效',
  3009: '凭证不存在',
  3010: '凭证不属于该应用',
  3011: '应用名称已存在',
  3012: '无权执行此操作',
  3013: '应用名称格式不合法',
  3014: '应用描述过长',
  3015: '无效的运营模式',
  3016: '无效的登录模式',
  3017: '无效的计费规则',
  3018: '软件公告过长',
  3019: '基础数据过长',
  3020: '基础数据格式无效',
  3021: '免费运营模式下计费规则必须为不限制',
  3022: '无效的登录扣点间隔',
  3023: '无效的登录扣点点数',
  3024: '免费运营模式下不允许启用登录扣点',
  3025: '无效的解绑规则',
  3026: '无效的解绑扣时',
  3027: '无效的解绑扣点',
  3028: '无效的解绑冷却时间',
  3029: '免费运营模式下不允许设置解绑扣费',
  3030: '无效的注册规则',
  3031: '无效的每日注册上限',
  3032: '注册赠送配置无效',
  3033: '无效的注册赠送时长',
  3034: '无效的注册赠送点数',
  3035: '当前登录模式不支持开启注册',
  3047: '免费运营模式下不允许开启注册赠送',
  3048: '无效的注册审核模式',
  3049: '审核地区列表无效',
  3036: '推荐奖励配置无效',
  3037: '推荐注册奖励时长和点数不能同时为0',
  3038: '推荐人充值返利比例无效',
  3039: '被推荐人返利比例无效',
  3040: '返利比例之和超过50%',
  3041: '单次返利上限无效',
  3042: '充值返利有效天数无效',
  3043: '推荐每日上限无效',
  3044: '免费运营模式下不允许开启推荐奖励',
  3045: '推荐奖励已开启，注册配置中必须开启推荐码入口',
  3046: '注册已关闭，不能配置注册推荐奖励',
  3050: '最大设备数无效',
  3051: '生效范围无效',
  3052: '超限策略无效',
  3053: '禁止解绑模式下不允许开启设备换绑',
  3054: '换绑间隔无效',
  3055: '每日换绑次数上限无效',
  3060: '凭证数量超出上限',
  3063: '凭证类型不匹配',
  3064: '凭证已禁用',
  3065: 'HMAC 签名验证失败',
  3066: '请求时间戳过期',
  3067: 'Nonce 已被使用',
  3068: '请求体解密失败',
  3069: '加密主密钥未配置',
  3160: '时间戳容差必须在30-300秒之间',

  // 卡类
  3080: '卡类不存在',
  3081: '同应用下卡类名称已存在',
  3082: '卡类名称格式不合法',
  3083: '卡类类型无效',
  3084: '卡类面值无效',
  3085: '卡类价格无效',
  3086: '卡类描述过长',
  3087: '卡类已禁用',
  3088: '卡类有效期无效',
  3089: '卡密长度无效',
  3090: '卡密前缀无效',
  3091: '使用次数无效',
  3092: '卡类属性格式无效',

  // 代理商扩展
  3100: '所选卡类均已授权，无需重复申请',
  3120: '该代理商与您在此应用下无已通过的代理关系',

  // 钱包
  3110: '钱包不存在',
  3111: '余额不足',
  3112: '充值金额无效',

  // 远程变量
  3130: '远程变量不存在',
  3131: '同应用下变量名已存在',
  3132: '变量名格式不合法',
  3133: '变量值无效',
  3134: '变量值超过4096字节限制',
  3135: '变量描述过长',
  3136: '每个应用最多创建50个远程变量',

  // 远程函数
  3140: '远程函数不存在',
  3141: '同应用下函数名已存在',
  3142: '函数名格式不合法',
  3143: '函数代码不能为空',
  3144: '函数代码超过10KB限制',
  3145: '函数描述过长',
  3146: '超时时间无效',
  3147: '函数已禁用',
  3148: '函数执行超时',
  3149: '函数执行失败',
  3150: '函数参数格式无效',
  3151: '函数返回值格式无效',

  // 远程函数 KV 存储
  3180: 'KV 键不存在',
  3181: 'KV 键格式不合法，仅允许字母、数字及 _ : . -，长度 1-128',
  3182: 'KV 值无效，必须为可序列化的 JSON 值',
  3183: 'KV 值超过4096字节限制',
  3184: '过期时间无效，需为 0（永久）或 1 至 31536000 秒',
  3185: 'KV 键数量已达上限',
  3186: 'KV 键已存在',
  3187: 'KV 值不是整数，无法递增',
  3188: 'KV 递增结果超出整数范围',
  3189: '单次执行 KV 操作次数超过 100 次',

  // 属性模板
  3170: '属性模板不存在',
  3171: '同一开发者下模板名称已存在',
  3172: '模板名称不能为空且不超过100字符',
  3173: '模板至少需要一个属性项',
  3174: '模板项最多50个',
  3175: '属性键不能为空且不超过64字符',
  3176: '属性键不能重复',
  3177: '属性值必须为合法JSON',
  3178: '模板内容超过10KB限制',
  3179: '模板描述过长，最多255字符',

  // 终端用户
  6001: '用户名已存在',
  6002: '该应用已关闭注册',
  6003: '今日该IP注册次数已达上限',
  6004: '今日该设备注册次数已达上限',
  6005: '设备限制模式下必须提供 device_id',
  6006: '二级密码强度不足',
  6007: '二级密码不能与主密码相同',
  6008: '该应用要求填写推荐码',
  6009: '推荐码无效，未找到对应用户',
  6010: '邮箱格式无效',
  6011: '该邮箱已被注册',
  6012: '该应用注册时卡密为必填项',

  // 终端用户充值
  6020: '用户不存在',
  6021: '用户已被禁用',
  6022: '用户名或密码错误',
  6023: '您已使用过此卡密',

  // 终端用户登录
  6030: '用户不存在',
  6031: '用户名或密码错误',
  6032: '用户已禁用',
  6033: '用户审核中，请等待审核',
  6034: '当前登录模式不支持此方式',
  6035: '账户已到期',
  6036: '账户点数不足',
  6037: '在线设备数已达上限',
  6038: '卡密登录模式下卡密为必填',
  6039: '设备ID为必填',
  6040: '设备未绑定',

  // 终端用户信息查询
  6050: '用户不存在',

  // 终端用户修改密码
  6060: '用户名或密码错误',
  6061: '用户已禁用',
  6062: '未设置二级密码，无法修改密码',
  6063: '二级密码验证失败',
  6064: '新密码不能与当前密码相同',

  // 终端用户配置
  6070: '用户配置数据不能超过 10KB',
  6071: '用户配置格式无效',

  // 终端用户解绑
  6080: '当前应用禁止解绑设备',
  6081: '解绑冷却期未结束，请稍后再试',
  6082: '点数不足，无法解绑',
  6083: '剩余时间不足，无法解绑',
  6084: '要解绑的设备不在线',
  6085: '在线设备数已达上限，请先手动解绑一台设备后重试',
  6086: '今日解绑次数已达上限',

  // 终端用户心跳
  6090: '心跳检测未启用',
  6091: '用户已禁用',
  6092: '用户审核中，请等待审核',
  6093: '账户已到期',
  6094: '账户点数不足',
  6095: '会话已被踢出，请重新登录',

  // 远程扣点
  6100: '扣点余额不足',
  6101: '重复的扣点请求',
  6102: '扣点点数必须在1-100000之间',
  6103: '扣点原因不能为空且不超过200字符',
  6104: 'request_id不能为空且不超过64字符',

  // 功能配额
  6500: '功能配额不存在',
  6501: '功能配额已用完',
  6502: '功能配额已禁用',
  6503: '同应用下功能标识已存在',
  6504: '每个应用最多创建50个功能配额',
  6505: '功能标识格式不合法，必须以字母开头，仅允许字母、数字、下划线和连字符',

  // 批量操作
  6510: '无效的批量操作类型',
  6511: '批量操作用户数超过上限',
  6512: '未选择任何用户',
  6513: '批量操作值无效',
  6514: '批量操作执行失败',

  // 黑名单
  6200: 'IP已被列入黑名单',
  6201: '设备已被列入黑名单',
  6202: '该黑名单条目已存在',
  6203: '黑名单条目不存在',

  // 审计日志
  7001: '审计日志查询失败',

  // SKU 商品
  9001: '商品不存在',
  9002: '同应用下商品名已存在',
  9003: '商品名称格式不合法',
  9004: '商品描述过长',
  9005: '商品价格无效',
  9006: '关联卡类无效或已禁用',
  9007: '每个应用最多创建100个商品',
  9008: '商品已下架',

  // 支付
  8001: '支付金额无效',
  8002: '支付渠道无效',
  8003: '支付订单不存在',
  8004: '支付订单已过期',
  8005: '支付订单已支付',
  8006: '支付签名验证失败',
  8007: '支付网关请求失败',
  8008: '该应用尚未配置支付参数或已禁用',
  8009: '订单创建失败',
  8010: '购卡时卡类不存在',
  8011: '购卡时卡类已禁用',
  8012: '支付关联应用不存在',
  8013: '该应用尚未配置支付回调地址，请在支付配置中填写通知URL',
  8014: '该订单不属于当前应用',

  // 工单系统
  10001: '工单不存在',
  10002: '工单已关闭，无法操作',
  10003: '工单标题无效（1-200字符）',
  10004: '工单内容不能为空',
  10005: '工单内容过长（最多200字符）',
  10006: '无权访问该工单',
  10007: '未关闭工单数量已达上限（最多2个）',
  10008: '工单查询失败',
  10009: '您已被禁止提交工单',

  // 客户端日志
  11001: '日志内容不能为空',
  11002: '图片数据无效',
  11003: '图片总大小超过10MB限制',
  11004: '图片上传失败',
  11005: '日志不存在',
  11006: '日志查询失败',

  // 时段扣点功能
  6600: '时段扣点功能不存在',
  6601: '时段扣点功能已禁用',
  6602: '点数不足，无法使用该功能',
  6603: '同应用下功能标识已存在',
  6604: '每个应用最多创建50个时段扣点功能',
  6605: '功能标识格式不合法或去重键过长',

  // 转发功能
  6700: '转发功能不存在',
  6701: '转发功能已禁用',
  6702: '同应用下功能标识已存在',
  6703: '功能标识格式不合法',
  6704: '每个应用最多创建50个转发功能',
  6705: '转发功能配置参数无效',
  6706: '上游服务请求失败',
  6707: '透传路径或请求方法非法',

  // 权限/Token
  4001: '无权限',
  4002: '登录状态无效或已过期，请重新登录',

  // 系统
  5000: '服务器内部错误',
  5001: '数据库错误',
  5002: '缓存服务错误',
};

// 获取错误消息
export function getErrorMessage(code: number): string {
  return ERROR_MESSAGES[code] ?? `未知错误 (${code})`;
}
